import userService from "@/services/user.service"
import { resetRouter } from "@/router"
import config from "@/config"
import { ActionContext } from "vuex"
import { buildUserPatcher, UserMapper, buildUserProxy } from "@/utils/userPatcher"
import { omit } from "lodash"

export interface State {
    token: string
    uid: string
    oid: number
    noPermission: boolean
    name: string
    roles: string[]
    pages: { [key: number]: string }
    permissions: string[]
    email: string
    mobile: string
    department_name: string
    department_oid: number
    platform_id: string
    orgUser: any[]
    org: any[]
    allUser: UserMapper
    allOrgs: any
    allDepart: any[]
    // 所有邮箱
    emailAll: any[]
    // 所有邮箱群组
    groupAll: any[]
    is_account_admin: boolean
    is_email_admin: boolean
    property_role: string
    property_type: string[]
    havePreUser: any[]
}

const state: State = {
    token: "",
    uid: "",
    oid: 0,
    noPermission: false,
    name: "",
    email: "",
    mobile: "",
    department_name: "",
    department_oid: 0,
    pages: {},
    permissions: [],
    roles: [],
    platform_id: "",
    orgUser: [],
    org: [],
    allUser: [],
    allOrgs: [],
    allDepart: [],
    emailAll: [],
    groupAll: [],
    is_account_admin: false,
    is_email_admin: false,
    property_role: "",
    property_type: [],
    havePreUser: []
}
const userPatcher = buildUserPatcher("user/patchUser")
const actions = {
    async getUserInfo(context: ActionContext<State, any>) {
        const data: any = await userService.getUserBaseInfo()
        const permissionData: any = await userService.getPermission()
        const { roles = [] } = permissionData || {}
        data.roles = roles
        context.commit(
            "setUser",
            Object.assign({}, data, {
                noPermission: data.code === 10002003
            })
        )
        if (data.code) throw new Error(data.code === 10002003 ? "无权限" : "未登录")
    },
    async loginOut(context: ActionContext<State, any>) {
        context.commit("resetUser")
        resetRouter()
        const redirect = window.location.href
        window.location.href = `${config.api.SRED}?platform_id=${config.api.PID}&redirect=${escape(
            redirect
        )}&isLoginOut=1`
    },
    async getUserList(context: ActionContext<State, any>) {
        const data = await userService.getAllUserList()
        if (data.code) throw new Error("未登录")
        context.commit("setAllUser", data)
    },
    async getOrgUserList(context: ActionContext<State, any>) {
        context.commit("setOrgUser", await userService.getUserList())
    },
    async getOrgList(context: ActionContext<State, any>) {
        context.commit("setOrg", await userService.getUserList(false, false))
    },
    async getPreEnterList(context: ActionContext<State, any>) {
        context.commit("setPreEnter", await userService.getUserList(false, true, true))
    }
}

const mutations = {
    setUser(state: State, data: any) {
        state.uid = data.uid
        state.noPermission = data.noPermission
        state.oid = Number(data.division_oid)
        state.name = data.name
        state.roles = data.roles
        state.permissions = data.permissions
        state.pages = data.pages
        state.email = data.email
        state.mobile = data.mobile
        state.department_name = data.department_name
        state.platform_id = data.platform_id
        state.is_email_admin = data.is_email_admin
        state.is_account_admin = data.is_account_admin
        state.property_role = data.property_role
        state.property_type = data.property_type
    },
    cleanToken(state: State) {
        state.token = ""
        localStorage.removeItem("token")
    },
    resetUser(state: State) {
        state.token = ""
        state.name = ""
        state.permissions = []
        state.pages = []
        state.roles = []
        localStorage.removeItem("token")
    },
    patchUser(state: State, data: any[]) {
        const patch = data.reduce((prev, cur) => {
            const { department_tree_path_str, email, name, oid, thumb_avatar, uid } = cur
            return {
                ...prev,
                [cur.uid]: {
                    uid: uid,
                    thumb_avatar: thumb_avatar,
                    name: name,
                    email: email,
                    department_name: department_tree_path_str,
                    department_id: oid
                }
            }
        }, {})
        state.allUser = buildUserProxy({ ...state.allUser, ...patch }, userPatcher)
    },

    setAllUser(state: State, data: any) {
        state.allUser = buildUserProxy(data, userPatcher)
    },
    setPreEnter(state: State, data: any) {
        state.havePreUser = [data]
    },
    setOrgUser(state: State, data: any) {
        state.orgUser = [data]
    },
    setOrg(state: State, data: any) {
        const orgsArr = [data]
        const orgs: Record<string, any> = {}
        const handle = (arr: any[]) => {
            arr.forEach(elem => {
                if (elem.child_org && elem.child_org.length > 0) {
                    handle(elem.child_org)
                }
                const node = omit(elem, ["child_org", "user_list"])
                orgs[node.oid] = node
            })
        }
        handle(orgsArr)
        state.org = orgsArr
        state.allOrgs = orgs
    },
    setEmalAll(state: State, data: any) {
        state.emailAll = data.map((item: any) => ({
            label: item.email,
            value: item.email_id
        }))
    },
    setGroupAll(state: State, data: any) {
        state.groupAll = data.map((item: any) => ({
            label: item.group_name,
            value: item.group_id
        }))
    },
    setNoPermission(state: State) {
        state.noPermission = true
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
